module.exports = __webpack_public_path__ + "img/icon_map_0_on_011.5bb953af.png";